var CommonPayment = {
    totalAmount: null,
    totalCurrency: null,
    userAnonym: true,
    afsPaymentId: null,
    countryCode: null,
    metasearch: null,
    preventCouponUse: false,
    use3DSecure: false,
    useIFrameWhen3D: false,
    passengers: null,
    personInput: null,
    uiErrors: [],
    uiEvents: [],
    timeout: null,
    source: null,
    retryVposBinRequest: true,
    serviceType: '',
    creditCardFirstNumberCountToCheckVpos: 6,
    creditCardNumberLength: 16,
    discountAmount: null,
    insurance: 0,
    useBkm: false,
    bkmSuccessUrl: null,
    bkmFailUrl: null,
    serviceTypeForNoTRSite: '',
    userBalance: 0,
    isNeedCreditCard:false,
    hasAlternativePayment:false
};
